import Chart from 'react-apexcharts'
import { useSelector } from 'react-redux'

function ApexChart({options, type, series, height, width, dropShadow, overrideTheme}){
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    return <Chart 
        {...(dropShadow ? {dropShadow} : {})}
        series={series}
        height={height}
        width={width}
        options={{
            ...options, 
            grid: {
                ...(options.grid ?? {}),
                show: useDarkMode ? false : true,   
                borderColor: useDarkMode ? "#2d353c" : '#e7e7e7',
                row: useDarkMode ? ({
                    colors: ['#2d353c'],
                }) : ({
                    colors: ['#f3f3f3', 'transparent'],
                    opacity: 0.5
                })
            },
            ...(options.series ? {theme: {
                mode: overrideTheme ? overrideTheme : useDarkMode ? "dark" : "light", 
                // monochrome: {
                //     enabled: true,
                //     color: '#255aee',
                //     shadeTo: overrideTheme ? overrideTheme : useDarkMode ? "dark" : "light",
                //     shadeIntensity: 0.65
                // }
            }} : {}),
            tooltip: {
                ...options.tooltip,
                theme: overrideTheme ? overrideTheme : useDarkMode ? "dark" : "light"
            }
        }} type={type} />
}

export default ApexChart